import Routes from '../routes/routes'
import { buildGetApi } from './helpers'
import buildOptions from './buildApiOptions'

export default buildGetApi({
    route: Routes.apiGetCookies,
    buildResult: (values) => values.map(({name: n, type, domain}) => ({ name: n, type, domain })),
    buildOptions,
})
